import { ThemeToggle } from "./theme-toggle";

/**
 * ONE HEADER FOR THE TWO PUBLIC PAGES, the dark switch in the same place on
 * both. Full width and sticky: the
 * business on the left, the light/dark switch always last on the right, and
 * -- on an item of a published profile -- the way back to it just before it:
 * «‹ Ver perfil», or «‹ Ver tienda» while the profile is only a shop of
 * products (`profileLayoutOf`'s `shopWord`).
 *
 * `heading` makes the business's name the page's <h1>; on an item the <h1>
 * is the item's own name, and on the profile its sign's, so there it is
 * plain text. `quiet` keeps the business out of the bar while the profile's
 * own sign is on screen, so the name is not said twice at the top.
 */
export function PublicHeader({
  name,
  logoSrc,
  heading,
  shopHref,
  backLabel = "‹ Ver perfil",
  quiet = false,
}: {
  name: string;
  logoSrc: string | null;
  heading: boolean;
  shopHref: string | null;
  backLabel?: string;
  quiet?: boolean;
}) {
  return (
    <header className={quiet ? "public-top public-top--quiet" : "public-top"}>
      {logoSrc === null ? (
        <span className="share-logo share-logo--initial" aria-hidden="true">
          {name.trim().charAt(0).toUpperCase()}
        </span>
      ) : (
        <img className="share-logo share-logo--image" src={logoSrc} alt="" height={40} />
      )}
      {heading ? <h1 className="public-name">{name}</h1> : <span className="public-name">{name}</span>}
      {shopHref === null ? null : (
        <a className="share-to-shop" href={shopHref}>
          {backLabel}
        </a>
      )}
      <ThemeToggle />
    </header>
  );
}

/** The header while the page loads: the same bar, so nothing jumps when it arrives. */
export function PublicHeaderSkeleton() {
  return (
    <header className="public-top">
      <span className="share-logo share-skeleton" />
      <span className="share-skeleton share-skeleton--line" style={{ width: "30%" }} />
    </header>
  );
}
